let masterDataPromise = null;

async function fetchMasterDataFromApi() {
  const response = await fetch("/api/master", {
    headers: { Accept: "application/json" },
    credentials: "same-origin",
  });

  if (!response.ok) {
    throw new Error(
      "master fetch failed: " +
        response.status +
        " " +
        response.statusText
    );
  }

  const responseData = await response.json();

  return {
    roles:
      responseData && responseData.roles
        ? responseData.roles
        : [],
    prefectures:
      responseData && responseData.prefectures
        ? responseData.prefectures
        : [],
  };
}

export function getMasterData() {
  if (!masterDataPromise) {
    masterDataPromise = fetchMasterDataFromApi().catch((error) => {
      // 失敗したら次回再取得できるようにリセット
      masterDataPromise = null;
      throw error;
    });
  }

  return masterDataPromise;
}